// @ts-nocheck
export default (value?: boolean) => value === true || value === undefined;
